import { Link } from 'react-router-dom';
import '../index.css';

const Product3 = () => {
  return (
    <div className="product-detail-page">
      <header className="products-header">
        <div className="section-inner">
          <Link to="/produtos" className="back-button">
            ← Voltar para Produtos
          </Link>
          <h1 className="products-title">Bíblia do Lovable</h1>
          <p className="products-subtitle">101 Hacks e Prompts Que Vão Revolucionar Seus Projetos</p>
        </div>
      </header>

      <section className="coming-soon-section">
        <div className="section-inner">
          <div className="coming-soon-box">
            <img src="https://static.lumi.new/1e/1e7f1d164b44b0a76d3eda0dd183f9dc.webp" alt="Bíblia do Lovable" style={{ width: '100%', maxWidth: 400, borderRadius: 16, marginBottom: 24, boxShadow: '0 8px 32px rgba(147, 112, 219, 0.4)' }} />
            <h2>Bíblia do Lovable</h2>
            <p>101 Hacks e Prompts Que Vão Revolucionar Seus Projetos</p>
            <a href="https://abibliadolovable.lovable.app/" target="_blank" rel="noopener noreferrer" className="cta-button-primary" style={{ marginTop: 16, marginBottom: 8 }}>
              🔥 Acessar a Bíblia do Lovable
            </a>
            <Link to="/produtos" className="cta-button-primary" style={{ background: 'rgba(255,255,255,0.1)', marginTop: 8 }}>
              ← Ver Todos os Produtos
            </Link>
          </div>
        </div>
      </section>

      <footer className="site-footer">
        <div className="section-inner">
          <div className="footer-brand">
            <img src="https://static.lumi.new/00/0011bb058a2686e447915d0083474f56.webp" alt="Mestre Lovable Infinity" className="footer-logo" />
            <span className="footer-name">Extensão Lovable Ilimitado</span>
          </div>
          <p className="footer-copy">&copy; 2026 Mestre do Lovable - Todos os direitos reservados</p>
        </div>
      </footer>
    </div>
  );
};

export default Product3;
